import { render, staticRenderFns } from "./rzqn.vue?vue&type=template&id=82b625c6&scoped=true"
import script from "./rzqn.vue?vue&type=script&lang=js"
export * from "./rzqn.vue?vue&type=script&lang=js"
import style0 from "./rzqn.vue?vue&type=style&index=0&id=82b625c6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82b625c6",
  null
  
)

export default component.exports